import React from "react";
import { Component } from "react";
import request from "superagent";
import { defaultPaperPadding, url_endpoint } from "../../../config";
import LoaderSpinner from "../../../componentes/LoaderSpinner";
import checkLogin from "../../Utils/checkLogin";
import authHeader from "../../Utils/AuthHeader";
import { Accordion, AccordionDetails, AccordionSummary, Button, Collapse, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid, Paper, TextField } from "@material-ui/core";
import palette from "../../../theme/palette";
import questionsImg from '../../../images/background.png'
import ExpandMoreIcon from '../../../images/icons/expanded_icon.svg'
import CollapsedIcon from '../../../images/icons/collapsed_icon.svg'

class FaqQuestion {
    constructor(id, question, answer) {
        this.id = id
        this.question = question
        this.answer = answer
    }
}

export default class Help extends Component {
    constructor(props) {
        super(props)
        props.setTitulo('Ajuda');

        this.state = {
            clientData: null,
            loading: true,
            dialogOpen: false,
            dialogTitle: '',
            dialogMessage: '',
            questions: [],
            expandedId: null,
            sendingHelp: false,
            name: '',
            mail: '',
            message: '',
            faqPage: 1,
        }
    }

    async componentDidMount() {
        try {
            const clientData = await checkLogin(false)

            await this.getQuestions()

            this.setState({ loading: false, clientData: clientData, mail: clientData.email })
        } catch (e) {
            console.log(e)
        }
    }

    async getQuestions() {
        const resFaq = await request.get(url_endpoint + `faq/questions/${this.state.faqPage}`).set(authHeader())

        const fetchedQuestions = resFaq.body.map(data => new FaqQuestion(data.id, data.question, data.answer))

        this.setState({ questions: [...this.state.questions, ...fetchedQuestions] })
    }

    async sendHelpMessage() {
        try {
            this.setState({ loading: true })
            await request.post(url_endpoint + `faq/sendHelpMail`).field('name', this.state.name).field('mail', this.state.mail).field('message', this.state.message).set(authHeader())

            this.setState({ loading: false, name: '', mail: '', message: '', sendingHelp: false })
            this.openDialog('Mensagem enviada com sucesso', 'Obrigado pela sua mensagem, entraremos em contato em breve.')
        } catch (e) {
            this.setState({ loading: false })
            const msg = e.response.text
            this.openDialog('Erro ao enviar mensagem', msg)
        }
    }

    openDialog(title, message) {
        this.setState({ dialogOpen: true, dialogTitle: title, dialogMessage: message })
    }

    formIsValid() {
        if (this.state.sendingHelp == false) {
            return false
        }
        return this.fieldIsValid(this.state.name) && this.fieldIsValid(this.state.mail) && this.fieldIsValid(this.state.message)
    }

    fieldIsValid(value) {
        if (value == '') {
            return false
        }

        return true
    }

    render() {
        let width = window.innerWidth
        window.onresize = () => {
            width = window.innerWidth
            this.setState({})
        }

        let isMobile = width < 1280

        return <>
            {this.state.loading && <LoaderSpinner></LoaderSpinner>}
            <Dialog
                open={this.state.dialogOpen}
                onClose={async () => {
                    this.setState({ dialogOpen: false })
                }}
            >
                <DialogTitle>
                    <span style={{ 'color': palette.primary.main, fontSize: '20px' }}>{this.state.dialogTitle}</span>
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        <span style={{ fontSize: '14px' }}>{this.state.dialogMessage}</span>
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <span onClick={async () => {
                        this.setState({ dialogOpen: false })
                    }} style={{ cursor: 'pointer', 'color': palette.primary.main, fontSize: '16px' }}>
                        {"OK"}
                    </span>
                </DialogActions>
            </Dialog>
            <Grid style={{ height: '85vh' }} container spacing={2}>
                <Grid item xs={12} sm={12} md={6} lg={8} xl={8}>
                    <div style={{ height: '100%', position: 'relative' }}>
                        {!isMobile &&
                            <img style={{ position: 'absolute', top: '0', left: '0', width: '30%', height: '100%', objectFit: 'cover' }} src={questionsImg}></img>
                        }
                        <Paper style={{ height: isMobile ? null : '85vh', marginLeft: isMobile ? '0' : '30%', padding: defaultPaperPadding, overflowY: isMobile ? 'hidden' : 'scroll' }}>
                            <h2 style={{ marginBottom: '18px', color: palette.primary.main }}>Dúvidas Frequentes</h2>
                            {this.state.questions.map((question) =>
                                <Accordion
                                    expanded={this.state.expandedId == question.id}
                                    onChange={(evt, expanded) => {
                                        console.log(expanded)
                                        this.setState({ expandedId: expanded ? question.id : null })
                                    }}
                                    style={{ border: `1px solid ${palette.primary.main}`, margin: '10px 0', borderRadius: '10px', position: 'inherit' }}>
                                    <AccordionSummary
                                        expandIcon={<img src={ExpandMoreIcon}></img>}
                                        id={question.id}
                                    >
                                        <h2 style={{ color: palette.primary.main }}>{question.question}</h2>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <h3 style={{ fontWeight: 'normal' }}>{question.answer}</h3>
                                    </AccordionDetails>
                                </Accordion>
                            )}
                        </Paper>
                    </div>
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
                    <Paper style={{ display: 'flex', flexDirection: 'column', rowGap: '18px', justifyContent: 'space-between', height: isMobile ? null : '85vh', padding: defaultPaperPadding, overflowY: isMobile ? 'hidden' : 'scroll' }}>
                        <h2 style={{ color: palette.primary.main }}>Precisa de suporte?
                            <br />
                            <span style={{ fontWeight: 'normal' }}>Entre em contato.</span>
                        </h2>

                        <TextField
                            error={this.state.sendingHelp ? !this.fieldIsValid(this.state.name) : false}
                            onChange={(e) => {
                                this.setState({ name: e.target.value })
                            }}
                            required={this.state.sendingHelp}
                            label="Nome"
                            value={this.state.name}
                            variant='filled'
                            style={{ border: '1px solid lightgrey', borderRadius: '4px', backgroundColor: 'white', boxShadow: '0px 0px 2px grey' }}
                            InputProps={{ disableUnderline: true, style: { backgroundColor: 'white' } }}
                        />
                        <TextField
                            error={this.state.sendingHelp ? !this.fieldIsValid(this.state.mail) : false}
                            onChange={(e) => {
                                this.setState({ mail: e.target.value })
                            }}
                            value={this.state.mail}
                            required={this.state.sendingHelp}
                            label="E-mail"
                            variant='filled'
                            style={{ border: '1px solid lightgrey', borderRadius: '4px', backgroundColor: 'white', boxShadow: '0px 0px 2px grey' }}
                            InputProps={{ disableUnderline: true, style: { backgroundColor: 'white' } }}
                        />
                        <TextField
                            error={this.state.sendingHelp ? !this.fieldIsValid(this.state.message) : false}
                            onChange={(e) => {
                                this.setState({ message: e.target.value })
                            }}
                            value={this.state.message}
                            required={this.state.sendingHelp}
                            label="Deixe sua dúvida"
                            variant='filled'
                            multiline
                            rows={20}
                            style={{ border: '1px solid lightgrey', borderRadius: '4px', backgroundColor: 'white', boxShadow: '0px 0px 2px grey' }}
                            InputProps={{ multiline: true, disableUnderline: true, style: { backgroundColor: 'white' } }}
                        />
                        <Button onClick={() => {
                            this.state.sendingHelp = true
                            this.setState({ sendingHelp: true })
                            console.log(this.formIsValid())
                            if (this.formIsValid()) {
                                this.sendHelpMessage()
                            }
                        }} variant="contained" color="primary" disabled={!this.formIsValid() && this.state.sendingHelp}>
                            Solicitar Ajuda
                        </Button>
                    </Paper>
                </Grid>
            </Grid >
        </>
    }
}